import { Component, Inject } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ProductCategoryService,
  ProductCategory,
  ProductCategoryUpdateInput,
} from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { PRODUCT_CATEGORY_DEFAULT_INSTALLMENT_PLAN } from 'src/app/shared/constants/operationals';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-product-category-update-steps-dialog',
  templateUrl: './product-category-update-steps-dialog.component.html',
  styleUrls: ['./product-category-update-steps-dialog.component.scss'],
})
export class ProductCategoryUpdateStepsDialogComponent {
  product_category_update_steps_from_group: FormGroup = this.form_service.product_category_update_steps_from_group;
  category?: ProductCategory;
  is_submit_running: boolean = false;
  default_lengths: number[] = PRODUCT_CATEGORY_DEFAULT_INSTALLMENT_PLAN;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  constructor(
    private dialog_ref: MatDialogRef<ProductCategoryUpdateStepsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private product_category_service: ProductCategoryService,
    private form_service: FormService,
    private error_service: ErrorService,
    private utils_service: UtilsService,
  ) {
    this.category = data.category;
  }
  ngOnInit(): void {
    this.product_category_update_steps_from_group.reset();
    this.buildProductCategoryForm();
    this.populateForm();
  }

  buildProductCategoryForm(): void {
    this.product_category_update_steps_from_group = this.product_category_service.buildProductCategoryForm(
      this.product_category_update_steps_from_group,
      this.default_lengths,
    );
  }

  populateForm(): void {
    if (this.category) {
      const installment_plans = JSON.parse(JSON.stringify(this.category.installment_plans));

      installment_plans.forEach((plan: any) => {
        plan.step_0_tax_percentage = plan.step_0_tax_percentage * 100;
      });

      this.getInstallmentPlans().patchValue(installment_plans);
    }
  }
  isFormValid(): boolean {
    return this.form_service.validateForm(this.product_category_update_steps_from_group);
  }

  getInstallmentPlans(): FormArray {
    return this.product_category_update_steps_from_group.get(
      this.form_service.product_category_installment_plans_label,
    ) as FormArray;
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onSubmitClick(): void {
    if (this.isFormValid()) {
      const form_installment_plans = this.product_category_update_steps_from_group.get(
        this.form_service.product_category_installment_plans_label,
      )?.value;

      const installment_plans = form_installment_plans?.map((plan: any) => ({
        plan_length: plan.plan_length,
        step_0_tax_percentage: Number(plan.step_0_tax_percentage),
      }));

      const params: ProductCategoryUpdateInput = {
        installment_plans: installment_plans || undefined,
      };

      this.updateProductCategory(params);
    }
  }

  updateProductCategory(product_category: ProductCategoryUpdateInput): void {
    this.is_submit_running = true;
    this.product_category_service
      .updateProductCategory(this.category?.product_category_id as string, product_category)
      .subscribe({
        next: () => {
          this.dialog_ref.close({ success: true });
          this.is_submit_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.dialog_ref.close({ error: processed_error });
          this.is_submit_running = false;
        },
      });
  }

  hasStepZeroMaxPercError(step_0_tax_percentage_label: string, index: number): boolean | undefined {
    return this.utils_service.hasStepZeroMaxPercError(
      this.getInstallmentPlans().at(index) as FormGroup,
      step_0_tax_percentage_label,
    );
  }

  getStepZeroMaxPercFormFieldErrorClass(
    step_0_tax_percentage_label: string,
    index: number,
  ): {
    [key: string]: boolean | undefined;
  } {
    return this.utils_service.getStepZeroMaxPercFormFieldErrorClass(
      this.getInstallmentPlans().at(index) as FormGroup,
      step_0_tax_percentage_label,
    );
  }
}
